import './Common/sentry';
import { CallQualityFeedback } from './ViewModels/doctor/CallQualityFeedbackViewModel';
import { ClockValidatorApp } from './features/clockValidator/ClockValidatorApp';
import { SetupAllDataApp } from './features/logbook/AllDataApp';

const w = window as any;

import * as ko from 'knockout';
w.ko = ko;

w.Hejdoktor = {
    CallQualityFeedback: CallQualityFeedback,
    ClockValidatorApp,
    SetupAllDataApp,
};
